import React from 'react';

interface StatusBadgeProps {
  active: boolean;
  /** Entity's own flag is true but a parent (organization) is deactivated */
  viaParent?: boolean;
}

/**
 * Uniform lifecycle badge for the Accounts tool: Active, Deactivated, or the
 * derived "Deactivated (via organization)" state — see
 * ACCOUNTS_TOOL_REQUIREMENTS.md §2.1.
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ active, viaParent = false }) => {
  if (active && !viaParent) {
    return (
      <span className="inline-flex rounded-full bg-success-100 px-2 py-0.5 text-xs font-medium text-success-800 dark:bg-success-900 dark:bg-opacity-40 dark:text-success-300">
        Active
      </span>
    );
  }
  return (
    <span
      className="inline-flex rounded-full bg-warning-100 px-2 py-0.5 text-xs font-medium text-warning-800 dark:bg-warning-900 dark:bg-opacity-40 dark:text-warning-300"
      title={active && viaParent ? 'Active itself, but its organization is deactivated' : undefined}
    >
      {active && viaParent ? 'Deactivated (via organization)' : 'Deactivated'}
    </span>
  );
};

export default StatusBadge;
